import { render, staticRenderFns } from "./productPage.vue?vue&type=template&id=682c1a95&"
import script from "./productPage.vue?vue&type=script&lang=js&"
export * from "./productPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports